<script setup>
import { ref } from 'vue'
import SubtopicCard from "@/components/about/overview/SubtopicCard.vue"

//properties set by parent
const props = defineProps({
  topic: {
    type: Object,
    required: true,
  }
})

//reactive field proxies
const topic = ref(props.topic)

</script>

<template>
	<article class="section">
		<div class="title">
			{{props.topic.title}}
		</div>
		<div class="separator-line"></div>
		<div :class="props.topic.anchor === 'Overview' ? 'description-long' : 'description'"
			v-html="props.topic.description">
		</div>
		<div v-if="props.topic.subtopics.length > 0" class="row">
			<div class="subtopic" v-for="(st) in props.topic.subtopics"
				:key="st.id">
				<SubtopicCard :topic="topic" :subtopic="st" />
			</div>
		</div>
	</article>
</template>

<style scoped>
.section {
	display: flex;
	justify-content:flex-start;
	flex-direction: column;
	padding: var(--spacing-7xl) var(--spacing-4xl);
	max-width: 72.5rem;
	margin-right: 14.5625rem;	
}


.row {
	display: flex;
	flex-direction: row;
	flex-wrap: wrap; 
	padding-top:  var(--spacing-4xl);
	gap: var(--spacing-2xl);
	justify-content: flex-start;

}

.subtopic { 
	box-sizing: border-box;
	text-align: left;
	flex: 0 0;
}

.title {
	font-size: var(--font-size-H2);
	font-family: var(--font-family-Title, Roboto);
	font-weight: 500;
	color: var(--text-text-Header);
	line-height: var(--font-line-height-H2);
}

.separator-line {
	width: 5rem;;
	height: 0.375rem;
	background-color: #005495;
	margin: 1.625rem 0;
}

.description {
	max-width: 50.75rem;
	color: var(--text-Primary);
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base);

	overflow: hidden;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 7;
	line-clamp: 7;
	align-self: stretch;
}
.description-long {
	max-width: 50.75rem;
	color: var(--text-Primary);
	font-family: var(--font-family-Title, Roboto);
	font-size: var(--font-size-Base);
	font-style: normal;
	font-weight: 400;
	line-height: var(--font-line-height-Base);
	-webkit-box-orient: vertical;
	align-self: stretch;
}

/* 1023px - iPad */
@media (max-width: 63.9375rem) {
	.section {
		margin-right: 0;
	}
}
</style>